import { __decorate, __metadata, __param } from "tslib";
import { backofficeUrlBase } from '@/config/envConfig';
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
import { buildFormDate } from '@/@core/utils/form';
let CoreUtilityApi = class CoreUtilityApi {
    constructor(http, authService) {
        this.http = http;
        this.authService = authService;
        this.baseUrl = backofficeUrlBase + '/backoffice';
        // #endregion
        this.postPostman = (params) => {
            return this.http.post({
                url: `${this.baseUrl}/tool/postman`,
                data: params,
            });
        };
        this.sendTargetConcurrencyEmail = (params) => {
            return this.http.post({
                url: `${this.baseUrl}/customer-package-email/send-target-email`,
                data: params,
            });
        };
        // batch-trial
        this.postBatchTrial = (params) => {
            const formData = buildFormDate(params);
            return this.http.post({
                url: `${this.baseUrl}/batch-trial/add`,
                data: formData,
            });
        };
        // account-job-role-complement
        this.postAccountJobRoleComplement = (params) => {
            const formData = buildFormDate(params);
            return this.http.post({
                url: `${this.baseUrl}/account-job-role-complement/upload`,
                data: formData,
            });
        };
    }
    getAuthService() {
        return this.authService.currentUser.id;
    }
    // #region account infomation
    getCompanyInfomation(data) {
        return this.http.get({
            url: `${this.baseUrl}/tool/company/info?id=${data}`,
        });
    }
    getUserInfomation(data) {
        return this.http.get({
            url: `${this.baseUrl}/tool/account/info?id=${data.userID}&emailOrMobile=${data.emailOrMobile}`,
        });
    }
    // #endregion
    // #region cache
    getDefaultList() {
        return this.http.get({
            url: `${this.baseUrl}/tool/redis/list`,
        });
    }
    getCacheData(params) {
        return this.http.post({
            url: `${this.baseUrl}/tool/redis/value`,
            data: params,
        });
    }
    deleteCache(params) {
        return this.http.delete({
            url: `${this.baseUrl}/tool/redis/value`,
            data: params,
        });
    }
    // #endregion
    // #region  limitation
    getLimitList() {
        return this.http.post({
        // url: `${CMS_URI}/api/cms/get-role-limit`
        });
    }
    // #endregion
    // #region gateway
    getLoadScript(host) {
        return this.http.post({
            url: `${this.baseUrl}/tool/acl/loadScript`,
            data: {
                host,
            },
        });
    }
    getFlush(products) {
        return this.http.post({
            url: `${this.baseUrl}/tool/acl/flushPermissions`,
            data: {
                host: products.host,
                products: [
                    products.product.param
                ],
            },
        });
    }
    // #endregion
    // #region alertTest
    getAlertTest(params) {
        return this.http.post({
            url: `${this.baseUrl}/tool/alert/process`,
            data: params,
            headers: {
                'X-User-ID': this.getAuthService(),
            },
        });
    }
    // #endregion
    // #region alertDebugger
    analysisAlert(params) {
        return this.http.post({
            url: `${this.baseUrl}/tool/alert/analysis-alert-cfd`,
            data: params,
            headers: {
                'X-User-ID': this.getAuthService(),
            },
        });
    }
    getAlertInfo(params) {
        return this.http.post({
            url: `${this.baseUrl}/tool/alert/alert-info`,
            data: params,
            headers: {
                'X-User-ID': this.getAuthService(),
            },
        });
    }
};
CoreUtilityApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.AuthService)),
    __metadata("design:paramtypes", [Object, Object])
], CoreUtilityApi);
export { CoreUtilityApi };
